<div class="c-card c-card--height-fixed">
    <div class="c-content c-content--border-bottom u-hidden@md-and-up" *ngIf="vm.chat">
        <div class="o-grid o-grid--center-v">
            <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
                <item-status [status]="vm.chat.privateChatFriend.status"></item-status>
            </div>
            <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
				<p data-testid="selected-chat-user-name" style="overflow: hidden;text-overflow: ellipsis;max-width:200px;white-space: nowrap;" class="c-text c-text--lg c-text--bold">
					{{ vm.chat.privateChatFriend.fullName }}
                </p>
            </div>
	        <div *ngIf="vm.chat && vm.chat.id && vm.user && vm.user?.businessUserType === 'SERVICE_PROVIDER'" class="o-grid__cell">
	            <input-switch-new style="float:right;" [isDisabled]="vm.chat.disabled"
	                      [toggleFn]="vm.toggleChatDisabled"
	                      [label]="">
	            </input-switch-new>
	        </div>
        </div>
    </div>
	<div style="background-color:#999999;" class="c-card__header2" *ngIf="vm.chat && vm.chat.id && vm.user && vm.user.businessUserType === 'SERVICE_PROVIDER'">
		<span *ngIf="!vm.isPreVisitChatOnly && vm.chat.extraInfo && vm.chat.extraInfo.businessName">{{vm.chat.extraInfo.businessName}}</span>
		<span *ngIf="!vm.isPreVisitChatOnly && vm.chat.extraInfo && !vm.chat.extraInfo.businessName">{{ 'Chats.Other.PrivateCustomer' | translate }}</span>
		<span *ngIf="!vm.isPreVisitChatOnly && vm.chat.extraInfo"> ({{vm.chat.extraInfo.origin}}). </span>
		<span *ngIf="!vm.isPreVisitChatOnly && vm.chat.preVisitMetaData?.type === 'PRE_VISIT'"> {{ 'Chats.Other.PreVisit' | translate }}</span>
		<span *ngIf="!vm.isPreVisitChatOnly && vm.chat.extraInfo && vm.chat.extraInfo.businessClientSettings && vm.chat.extraInfo.businessClientSettings.sessionLimit">{{ 'Chats.Other.Sessions_Used' | translate }}: </span>
		<span *ngIf="!vm.isPreVisitChatOnly && vm.chat.extraInfo && vm.chat.extraInfo.businessClientSettings && vm.chat.extraInfo.businessClientSettings.sessionLimit">{{vm.chat.extraInfo.businessClientSettings.sessionsUsed ? vm.chat.extraInfo.businessClientSettings.sessionsUsed : 0}}/{{vm.chat.extraInfo.businessClientSettings.sessionLimit}}</span>
		<div *ngIf="vm.chat && vm.chat.id && vm.user?.businessUserType === 'SERVICE_PROVIDER'" style="float:right;" class="o-grid__cell o-grid__cell--w-fixed u-hidden@up-to-md">
            <input-switch-new [isDisabled]="vm.chat.disabled"
                      [toggleFn]="vm.toggleChatDisabled"
                      [label]="(vm.chat.disabled ? 'Condition_Summary.Chat_Disabled' : 'Condition_Summary.Chat_Enabled') | translate">
	        </input-switch-new>
	    </div>
	</div>
	<div class="c-content c-content--fit c-content--wrapper u-no-p">
		<item-messenger class="o-grid o-grid--column o-grid--fit" [chat]="vm.chat"></item-messenger>
	</div>
</div>
<div class="o-grid o-grid--center-v o-grid--right u-ost-md u-osb-md" *ngIf="vm.chat && vm.chat.id">
	<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p">
		 <button id="checkAvailabilityButton" 
                 type="button"
                 style="min-width:220px;margin-bottom: 5px;"
                 class="c-button c-button--s1 c-button--fit@up-to-sm"
                 (click)="vm.checkChatAvailability()">
             {{ 'Chats.Other.Check_Chat_Availability' | translate }}
         </button>
         <span class="u-hidden@up-to-sm">&nbsp;</span>
	     <button id="openChatBotSummaryButton" 
	     		 *ngIf="vm.user?.service && vm.user?.service['mentalHealthServiceProvider'] && vm.chatBotSummary"
                 type="button"
                 style="min-width:220px;margin-bottom: 5px;"
                 class="c-button c-button--s1 c-button--fit@up-to-sm"
                 (click)="vm.openChatBotSummary()">
             {{ 'Chats.Other.Ai_Bot_Summary' | translate }}
         </button>
         <span *ngIf="vm.user?.service && vm.user?.service['mentalHealthServiceProvider'] && vm.chatBotSummary" class="u-hidden@up-to-sm">&nbsp;</span>
         <button id="openSummaryDialogButton"
         		 *ngIf="vm.user?.service && vm.user?.service['mentalHealthServiceProvider']" 
                 type="button"
                 style="min-width:220px;margin-bottom: 5px;"
                 class="c-button c-button--s1 c-button--fit@up-to-sm"
                 (click)="vm.openSummaryDialog()">
             <img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/icon-edit.svg"> {{ 'Condition_Summary.Summary' | translate }}
         </button>
	</div>
</div>
